import React from 'react';
import { NavItem, NavLink } from 'shards-react';
import type { Language } from '../../../types/common';
import type { QaCategory } from '../../../types/qa';

interface NavCategoryItemProps {
  language: Language;
  category: QaCategory;
  active: boolean;
  onSelect: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const NavCategoryItem = ({ language, category, active, onSelect }: NavCategoryItemProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log(selectedTab);
  // }, [selectedTab]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <NavItem id={category.id} onClick={onSelect}>
      <NavLink active={active} href="#" className="px-3 py-2">
        {category.name[language]}
      </NavLink>
    </NavItem>
  );
};

export default NavCategoryItem;
